
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ControlView',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {};
  },
});
